export type ProfileType = 'BLACKLISTED' | 'WHITELISTED' | 'BADGE';

export interface ProfileTypeFilterValue {
  value: ProfileType | undefined;
}

export interface ProfileTypeFilterOption {
  id: string;
  name: ProfileType;
  label: string;
}

export interface EmployeeIdFilterValue {
  value: string | undefined;
}

export interface BadgeIdFilterValue {
  value: string | undefined;
}

export interface StatusFilterValue {
  isEnabled: boolean | undefined;
}

export interface StatusFilterOption {
  id: string;
  name: string;
  value: boolean | undefined;
}

export const STATUS_FILTER_OPTIONS: StatusFilterOption[] = [
  { id: 'enabled', name: 'Enabled', value: true },
  { id: 'disabled', name: 'Disabled', value: false },
];

export interface PersonProfileFilters {
  profileType: ProfileTypeFilterValue;
  employeeId: EmployeeIdFilterValue;
  badgeId: BadgeIdFilterValue;
  status: StatusFilterValue;
}

export const PROFILE_TYPE_FILTER_OPTIONS: ProfileTypeFilterOption[] = [
  { id: 'blacklisted', name: 'BLACKLISTED', label: 'Unauthorized' },
  { id: 'badge', name: 'BADGE', label: 'Badge' },
];

export const DEFAULT_PERSON_PROFILE_FILTERS: PersonProfileFilters = {
  profileType: {
    value: undefined,
  },
  employeeId: {
    value: '',
  },
  badgeId: {
    value: '',
  },
  status: {
    isEnabled: undefined,
  },
};
